import Dexie from "dexie";
import db from "../Db";

var DeleteTypetb = Dexie.async(function* () {
  yield db.open();
  yield db.TYPETB.clear();
});

export default DeleteTypetb;
